"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.object.get-prototype-of.js");
var _react = _interopRequireDefault(require("react"));
var _semanticUiReact = require("semantic-ui-react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("../../../../../../common/utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var DollarCell = /*#__PURE__*/function (_React$Component) {
  _inherits(DollarCell, _React$Component);
  var _super = _createSuper(DollarCell);
  function DollarCell(props) {
    var _this;
    _classCallCheck(this, DollarCell);
    _this = _super.call(this, props);
    // make sure user doesn't click to the left of the dollar sign
    _this.adjustCursor = function (e) {
      var value = e.target.value;
      var isNegative = false;
      var selectionStart = e.target.selectionStart;
      if (value.indexOf('-') !== -1) {
        isNegative = true;
      }
      if (selectionStart === 0 || isNegative && selectionStart === 1) {
        _this.setState({
          cursorPosFromR: value.length - selectionStart - 1
        });
      }
    };
    _this.inputDollarChange = function (e, data) {
      var value = data.value,
        name = data.name;
      _this.setState({
        cursorPosFromR: e.target.value.length - e.target.selectionStart
      });
      _this.inputDollarChangeCore(name, value);
    };
    _this.inputDollarChangeCore = function (name, value) {
      var _this$props = _this.props,
        handleChange = _this$props.handleChange,
        allowNegative = _this$props.allowNegative;
      if (typeof value !== 'undefined' && value !== null) {
        value = (0, _utils.onlyAllowNumbers)(value);
        if (!allowNegative) {
          // strip hyphens (allowed as numbers)
          value = value.replace(/-/g, '');
        } else {
          value = (0, _utils.formatDollarHyphen)(value.toString());
        }
        value = (0, _utils.onlyTwoDecimals)(value);
      }
      handleChange(name, value);
    };
    _this.inputDollarBlur = function (e) {
      var _this$props2 = _this.props,
        handleBlur = _this$props2.handleBlur,
        name = _this$props2.name,
        value = _this$props2.value;
      var input = e.target;
      if (input !== undefined) {
        _this.setState({
          cursorPosFromR: input.value.length - input.selectionStart
        });
      }
      var newValue = !(0, _utils.checkIfValuesAre)([null, undefined, ''], value) ? (0, _utils.formatDollarDecimals)(value.toString()) : value;
      // the only way to make sure the .00 is added to the end
      // before the number is saved to parent state and redux
      // (so clicking away always adds decimals)
      _this.inputDollarChangeCore(name, newValue);
      handleBlur();
    };
    _this.render = function () {
      var _this$props3 = _this.props,
        displayError = _this$props3.displayError,
        errorMessages = _this$props3.errorMessages,
        name = _this$props3.name,
        value = _this$props3.value,
        width = _this$props3.width,
        id = _this$props3.id,
        type = _this$props3.type,
        placeholder = _this$props3.placeholder,
        warning = _this$props3.warning,
        warningTitle = _this$props3.warningTitle,
        allowNegative = _this$props3.allowNegative,
        title = _this$props3.title;
      var dollarValue = !(0, _utils.checkIfValuesAre)([null, undefined, ''], value) ? '$' + (0, _utils.formatDollarCommas)(value.toString().replace(/^\$/g, '')) : '$';
      if (allowNegative && dollarValue.indexOf('-') !== -1) {
        dollarValue = '-' + dollarValue.replace('-', '');
      }
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Table.Cell, {
        className: "femaGoTableDollarCell",
        width: width
      }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Form.Field, null, /*#__PURE__*/_react.default.createElement("div", {
        className: "ui right icon input"
      }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Input, {
        className: displayError ? 'rightAligned errorFieldBorder' : 'rightAligned',
        placeholder: placeholder,
        id: id,
        fluid: true,
        name: name,
        onChange: _this.inputDollarChange,
        onBlur: _this.inputDollarBlur,
        onFocus: _this.adjustCursor,
        value: dollarValue,
        type: type,
        "aria-label": title
      }), warning && /*#__PURE__*/_react.default.createElement("div", {
        className: "icon",
        style: {
          paddingLeft: '4px'
        }
      }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Icon, {
        className: "warningInputPrice",
        name: "warning sign",
        color: "yellow",
        title: warningTitle
      }))), displayError && /*#__PURE__*/_react.default.createElement("div", {
        className: "errorMessages"
      }, errorMessages))));
    };
    _this.state = {
      cursorPosFromR: 0
    };
    return _this;
  }
  _createClass(DollarCell, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      // must check if input is focused already before using setSelectionRange for I.E.
      if (document.activeElement && this.props.id === document.activeElement.id) {
        var input = document.activeElement;
        var currCursorPosFromR = this.state.cursorPosFromR;
        // set cursors to appropriate position in the string
        var cursorPosFromL = input.value.length - currCursorPosFromR;
        input.setSelectionRange(cursorPosFromL, cursorPosFromL);
      }
    }
  }]);
  return DollarCell;
}(_react.default.Component);
DollarCell.propTypes = {
  /** For the input */
  optional: _propTypes.default.bool,
  value: _propTypes.default.any,
  size: _propTypes.default.string,
  hintText: _propTypes.default.string,
  /* Error */
  displayError: _propTypes.default.bool,
  errorMessages: _propTypes.default.any,
  /** Functions */
  handleChange: _propTypes.default.func.isRequired,
  handleBlur: _propTypes.default.func
};
var _default = DollarCell;
exports.default = _default;